module.exports = __webpack_public_path__ + "img/smileitup.37443d65.svg";